import api from '../utils/api';
class LanguageApi {
    getAll = (data) => {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await api
                    .get("/languages", { params: data });
                resolve(res.data);
            } catch (error) {
                reject(error);
            }
        });
    };
    create = (data) => {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await api
                    .post("/languages", data);

                resolve(res.data);
            } catch (error) {
                console.error(error);
                reject(error);
            }
        });
    };
    update = (id, data) => {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await api
                    .put(`/languages/${id}`, data);
                resolve(res.data);
            } catch (error) {
                reject(error);
            }
        });
    };

    delete = (id) => {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await api
                    .delete(`/document/${id}`);
                resolve(res.data);
            } catch (error) {
                reject(error);
            }
        });
    };

    getDetail = (id) => {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await api
                    .get(`/document/${id}`);
                resolve(res.data);
            } catch (error) {
                reject(error);
            }
        });
    };

}
const langageApi = new LanguageApi();
export default langageApi;